<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_content" class="app-content flex-column-fluid">
  <!--begin::Content container-->
  <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
      <!--begin::Page title-->
      <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
        <!--begin::Title-->
        <div class="d-flex align-items-center">
          <h1 class="page-heading"> <svg width="41" height="44" viewBox="0 0 41 44" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_615_2549)">
                <path
                  d="M15.1976 30.5794C16.2337 29.2326 17.8276 28.4404 19.5013 28.4404H25.7973C26.7537 28.4404 27.6303 28.0443 28.2679 27.4105L36.0782 19.3298C36.3173 19.0922 36.3173 18.6168 36.0782 18.3792C35.8391 18.1415 35.4406 18.0623 35.2016 18.2207L27.8694 22.5779C27.6303 23.7663 26.5943 24.7169 25.3191 24.7169H17.987C17.5885 24.7169 17.19 24.4 17.19 23.9247C17.19 23.5286 17.5885 23.1325 17.987 23.1325H25.3191C25.877 23.1325 26.3552 22.6572 26.3552 22.1026C26.3552 21.5481 25.877 21.0727 25.3191 21.0727H14.1616C12.5676 21.0727 11.0534 21.7857 10.097 22.9741L7.30762 26.3014L14.4803 31.6885L15.1976 30.5794Z"
                  fill="#265D91" />
                <path
                  d="M14.8784 33.9066L14.1611 33.352L6.27108 27.4104L4.75684 29.3117L13.3641 35.8079L14.8784 33.9066Z"
                  fill="#265D91" />
                <path
                  d="M9.93705 17.2701H30.8177C31.4552 17.2701 31.9334 16.7948 31.9334 16.161V10.1401C28.108 11.4869 24.2028 12.1999 20.3773 12.1999C16.5519 12.1999 12.6467 11.4869 8.82129 10.1401V16.161C8.82129 16.7948 9.29947 17.2701 9.93705 17.2701Z"
                  fill="#265D91" />
                <path
                  d="M31.9334 8.15949V4.59451C31.9334 3.96073 31.4552 3.4854 30.8177 3.4854H25.7967V1.10874C25.7967 0.633412 25.3983 0.158081 24.8404 0.158081H15.9143C15.4361 0.158081 14.958 0.55419 14.958 1.10874V3.4854H9.93705C9.29947 3.4854 8.82129 3.96073 8.82129 4.59451V8.15949C16.4722 11.0115 24.2825 11.0115 31.9334 8.15949ZM16.791 1.98018H23.884V3.40618H16.791V1.98018ZM19.1819 6.97116C19.1819 6.25817 19.7398 5.62439 20.3773 5.62439C21.0149 5.62439 21.5728 6.17894 21.5728 6.97116C21.5728 7.68416 21.0149 8.31793 20.3773 8.31793C19.7398 8.31793 19.1819 7.68416 19.1819 6.97116Z"
                  fill="#265D91" />
              </g>
              <defs>
                <filter id="filter0_d_615_2549" x="0.756836" y="0.158081" width="39.501" height="43.6498"
                  filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_615_2549" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_615_2549" result="shape" />
                </filter>
              </defs>
            </svg>

            Nos offres d’emploi
          </h1>
        </div>
        <!--end::Title-->
        <!--begin::Breadcrumb-->
        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
          <!--begin::Item-->
          <li class="breadcrumb-item text-muted">
            <a routerLink="/accueil" class="text-muted">Accueil</a>
          </li>
          <!--end::Item-->
          <!--begin::Item-->
          <li class="breadcrumb-item">
            <span class="bullet bg-gray-400 w-5px h-2px"></span>
          </li>
          <!--end::Item-->
          <!--begin::Item-->
          <li class="breadcrumb-item text-muted"><a class="text-muted"
              routerLink="/offres-emploi/liste-offres-emploi">Liste des offres d'emploi</a></li>
          <li class="breadcrumb-item">
            <span class="bullet bg-gray-400 w-5px h-2px"></span>
          </li>
         
          <li class="breadcrumb-item text-muted" *ngIf="value == 0" style="cursor: pointer;"><a class="text-muted"
            (click)="navigateToBareme()">Ajouter Barème</a></li>
          <li *ngIf="value == 0" class="breadcrumb-item">
            <span class="bullet bg-gray-400 w-5px h-2px"></span>
          </li>
          <li class="breadcrumb-item text-muted">{{action === 'update'?'Modifier le':'Ajouter de'}}  test</li>
          <!--end::Item-->
        </ul>
        <!--end::Breadcrumb-->
      </div>
      <!--end::Page title-->
      <!--begin::Actions-->

      <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
  </div>
  <div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Card-->
    <div class="card pb-15 pt-5 content-table">

      <div class="card-body">

        <div class="d-flex flex-wrap my-1 header-grid align-items-center mb-15">
          <div class="section-title">
            <ng-container *ngIf="testType === 'NO_TEST'; else simpleHeader">
              <button (click)="redirectTest()" class="btn-redirect-section-header"> 
                Test WeGestU
              </button>
              <button class="btn-redirect-section-header-disabled ms-5" disabled> 
                Test Entreprise
              </button>
          </ng-container>
          <ng-template #simpleHeader>
            <h1 class="section-heading my-0">{{action === 'update'?'Modifier ':'Ajouter'}}  un test </h1>
          </ng-template>
          </div>
          <!--begin::Tab nav-->

          <!--end::Tab nav-->
          <!--begin::Wrapper-->

          <!--end::Wrapper-->
        </div>

        
        <!--begin::Card header-->
        <div class="card-header border-0 pt-6 mb-4">
          <!--begin::Card title-->


          <!--begin::Card title-->
          <!--begin::Card toolbar-->
          <div class="card-toolbar">
           
            <!--begin::Toolbar-->
            <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
              <!--begin::Filter-->

              <!--end::Filter-->
              <!--begin::Export-->

              <!--end::Export-->
              <!--begin::Add customer-->
          

              <button type="button" class="btn  ajouter" (click)="openModal(add_update_question,'create_question')">+
                Ajouter Question</button>
              <!--end::Add customer-->
            </div>
            <!--end::Toolbar-->
            <!--begin::Group actions-->

            <!--end::Group actions-->
          </div>

          
          <!--end::Card toolbar-->
        </div>
         <div class="info-message mx-10 mb-7" *ngIf="creationTestPayload.questions.length <= 1">
              <span class="requirements mb-3">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_379_198)">
                  <path
                    d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                    fill="#2b5d8f" />
                </g>
                <defs>
                  <clipPath id="clip0_379_198">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Ajoutez au moins deux questions pour pouvoir créer le test.
            </span>
        </div>
        <!--end::Card header-->
        <!--begin::Card body-->
        <div class="card-body pt-0" *ngFor="let element of creationTestPayload?.questions; let i =index">
          <div class="item mb-5">
            <div class="item-header">
              <div class="left">
                <span class="number">{{ i + 1 }}</span>
                <h4>{{element.question_FR}}
                  <span *ngIf="['1', '2'].includes(element.response_state) && element.time " class="badge">({{element.time +' Secondes'}})</span>
                </h4>
              </div>
              <div class="right">
                <button class="edit" (click)="openDeleteQuestionAlert(element)">
                  <svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_440_1235)">
                      <path
                        d="M21.3004 6.0961H22.1502C22.3756 6.0961 22.5917 6.00657 22.7511 5.8472C22.9105 5.68784 23 5.47169 23 5.24631C23 5.02093 22.9105 4.80478 22.7511 4.64541C22.5917 4.48604 22.3756 4.39651 22.1502 4.39651H17.9012V3.54671C17.8992 2.87119 17.63 2.22391 17.1523 1.74624C16.6746 1.26858 16.0273 0.999332 15.3518 0.997314H10.253C9.57751 0.999332 8.93023 1.26858 8.45256 1.74624C7.97489 2.22391 7.70565 2.87119 7.70363 3.54671V4.39651H3.8498C3.62442 4.39651 3.40827 4.48604 3.2489 4.64541C3.08953 4.80478 3 5.02093 3 5.24631C3 5.47169 3.08953 5.68784 3.2489 5.8472C3.40827 6.00657 3.62442 6.0961 3.8498 6.0961H4.30444V18.8431C4.30444 19.97 4.7521 21.0507 5.54894 21.8476C6.34578 22.6444 7.42653 23.0921 8.55343 23.0921H17.0514C18.1783 23.0921 19.2591 22.6444 20.0559 21.8476C20.8527 21.0507 21.3004 19.97 21.3004 18.8431V6.0961ZM11.1028 17.1435C11.1028 17.3689 11.0133 17.585 10.8539 17.7444C10.6946 17.9037 10.4784 17.9933 10.253 17.9933C10.0276 17.9933 9.8115 17.9037 9.65213 17.7444C9.49276 17.585 9.40323 17.3689 9.40323 17.1435V10.3451C9.40323 10.1197 9.49276 9.90356 9.65213 9.7442C9.8115 9.58483 10.0276 9.4953 10.253 9.4953C10.4784 9.4953 10.6946 9.58483 10.8539 9.7442C11.0133 9.90356 11.1028 10.1197 11.1028 10.3451V17.1435ZM16.2016 17.1435C16.2016 17.3689 16.1121 17.585 15.9527 17.7444C15.7933 17.9037 15.5772 17.9933 15.3518 17.9933C15.1264 17.9933 14.9103 17.9037 14.7509 17.7444C14.5915 17.585 14.502 17.3689 14.502 17.1435V10.3451C14.502 10.1197 14.5915 9.90356 14.7509 9.7442C14.9103 9.58483 15.1264 9.4953 15.3518 9.4953C15.5772 9.4953 15.7933 9.58483 15.9527 9.7442C16.1121 9.90356 16.2016 10.1197 16.2016 10.3451V17.1435ZM16.2016 4.39651H9.40323V3.54671C9.40323 3.32133 9.49276 3.10518 9.65213 2.94581C9.8115 2.78644 10.0276 2.69691 10.253 2.69691H15.3518C15.5772 2.69691 15.7933 2.78644 15.9527 2.94581C16.1121 3.10518 16.2016 3.32133 16.2016 3.54671V4.39651Z"
                        fill="#EE6352" />
                    </g>
                    <defs>
                      <filter id="filter0_d_440_1235" x="0" y="0.997314" width="28" height="30.0947"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha" />
                        <feOffset dx="1" dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_440_1235" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_440_1235" result="shape" />
                      </filter>
                    </defs>
                  </svg>
                </button>
                <button class="edit" (click)="openModal(add_update_question,'edit_question', element, i)">
                  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_142_1063)">
                      <path
                        d="M4 15.6558V5.59137C4 4.9982 4.23707 4.42933 4.65906 4.00989C5.08106 3.59046 5.6534 3.35482 6.25019 3.35482H13.1301L10.9165 5.59137H6.25019V15.6558H16.376V11.0206L18.6262 8.82039V15.6558C18.6262 16.249 18.3891 16.8179 17.9671 17.2373C17.5451 17.6567 16.9728 17.8924 16.376 17.8924H6.25019C5.6534 17.8924 5.08106 17.6567 4.65906 17.2373C4.23707 16.8179 4 16.249 4 15.6558ZM20.3138 0C19.8664 0.000391512 19.4374 0.177375 19.1212 0.492041L11.1246 8.56878C10.8786 8.8174 10.6929 9.11861 10.5818 9.44942L9.77173 11.8677C9.76161 11.9064 9.76183 11.947 9.77238 11.9855C9.78293 12.0241 9.80343 12.0592 9.83185 12.0875C9.86028 12.1157 9.89564 12.1361 9.93443 12.1466C9.97322 12.1571 10.0141 12.1573 10.053 12.1473L12.4944 11.3505C12.8273 11.2401 13.1304 11.0556 13.3805 10.8109L21.5064 2.86278C21.7422 2.6282 21.9027 2.32944 21.9677 2.00425C22.0326 1.67906 21.9992 1.34202 21.8716 1.03569C21.744 0.729368 21.5279 0.4675 21.2507 0.283164C20.9734 0.098828 20.6474 0.000291618 20.3138 0Z"
                        fill="#265D91" />
                    </g>
                    <defs>
                      <filter id="filter0_d_142_1063" x="0" y="0" width="26" height="25.8924"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha" />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_142_1063" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_142_1063" result="shape" />
                      </filter>
                    </defs>
                  </svg>
                </button>

              </div>
            </div>
            <div *ngIf="element.response_state === '1'">
            <div class="item-content" *ngFor="let res of element.response_question">
              <div class="question">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input checkbox-border" [checked]="res.state"
                    type="checkbox" value="1" id="flexCheckDefault" [disabled]="true"/>
                  <label class="form-check-label" for="flexCheckDefault">
                    {{res.response_FR}}
                  </label>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>

        <!-- <div class="alert alert-warning text-center mt-5" role="alert" *ngIf="creationTestPayload?.questions && creationTestPayload.questions.length < 1">
          <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
          <span class="empty-list">
            La liste est vide
          </span>
        </div> -->
        <app-empty-state *ngIf="creationTestPayload?.questions && creationTestPayload.questions.length < 1"
          [title]="parentItem"></app-empty-state>

        <div class="row">
          <div class="actions add mt-10">
              <a class="annuler cursor-pointer" routerLink="/offres-emploi/liste-offres-emploi">Annuler</a>
            <div class="publier">
              <a 
                class="publish" 
                [class.disabled]="!isTestQuestionsMinimal(creationTestPayload?.questions)" 
                (click)="isTestQuestionsMinimal(creationTestPayload?.questions) && addQuestionTest()"
              >
                Confirmer
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #add_update_question>
  <div class="modal-content" id="add_update_question" tabindex="-1" >
    <!--begin::Modal dialog-->
    <div class="  ">
      <!--begin::Modal content-->
      <div class="">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="">
            {{ mode == "create_question" ? "Ajouter " : "Modifier " }} Question
          </h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary"
            data-bs-dismiss="modal">
            <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
        </div>
        <div class="modal-body">
          <!--begin::Form-->
          <form id="kt_customers_export_form" class="form" [formGroup]="questionForm">
            <!--begin::Input group-->
            <!--begin::Label-->
            <div class="mb-5">
              <label for="question" class="required form-label">
                {{
                mode == "create_question" ? "Ajouter " : "Modifier "
                }}
                Question</label>
              <!-- (keypress)="keyPressTextArea($event)" -->
              <textarea type="text" (keydown.enter)="keyPressTextArea($event)" (keydown.tab)="keyPressTextArea($event)"
                id="textAreaInput" formControlName="question_FR" class="form-control" placeholder="Question"></textarea>

              <app-feild-error [control]="questionForm.get('question_FR')"></app-feild-error>
            </div>
          
            <label for="question" class="required form-label">
              Choisir type de réponse</label>
            <div class="filter-tools mt-10 mb-10">

              <div class="filter response-type">

                <div class="form-check mr-2 ">
                  <input class="form-check-input" type="radio" formControlName="response_state" name="response_state" value="2" (change)="sortType($event)"
                    id="flexCheckFreeResponse"  />
                  <label class="form-check-label mr-10" for="flexCheckFreeResponse">
                    Réponse libre(commentaire)
                  </label>
                </div>
                <div class="form-check mr2">
                  <input class="form-check-input" type="radio"  formControlName="response_state" name="response_state" value="1" (change)="sortType($event)"
                    id="flexCheckQCMResponse" />
                  <label class="form-check-label" for="flexCheckQCMResponse">
                    Choisir réponse (QCM)
                  </label>
                </div>
              </div>
            </div>
            <div class="mb-5" *ngIf="state == 1 || state == 2">
              <label for="question" class="required form-label">
                Temps (Secondes)</label>
              <input  type="number" (keypress)="keyPress($event)" formControlName="time" class="form-control"
                placeholder="temps" />
              <app-feild-error  [control]="questionForm.get('time')"></app-feild-error>
            </div>
            <span class="requirements mt-5" *ngIf="state == 2">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_379_198)">
                  <path
                    d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                    fill="#EE6352" />
                </g>
                <defs>
                  <clipPath id="clip0_379_198">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Le score de ce test est calculé manuellement</span>
            <div formArrayName="responses" *ngIf="state == 1">
              <div *ngFor="let diplome of responses.controls; let i = index" class="content-inside">
                <div class="question mb-3" [formGroupName]="i">
                  <div class="new-question">
                    <div class="reponse mb-5">
                      <label for="question" class="required form-label correct-check">{{
                        mode == "create_question" ? "Ajouter " : "Modifier"
                        }}
                        une réponse ({{i+1}})
                        <div class="form-check">
                          <input formControlName="state" class="form-check-input" type="checkbox" value="0"
                            id="correct" (change)="getstatevalue($event,i)" />
                        </div>
                      </label>
                      <textarea formControlName="response_FR" type="text" class="form-control"
                        placeholder="Ajouter une réponse" style="white-space: pre-line"></textarea>
                      <app-feild-error [control]="diplome.get('response_FR')"></app-feild-error>

                      <div *ngIf="isResponseDuplicate(i)">
                        <span class="error-message" style="color: red">Réponse en double ! Veuillez saisir une autre
                          réponse.</span>


                      </div>
                    </div>
                  </div>
                  <div class="delete-icon" *ngIf="
                        (i > 0 && mode == 'create_question') ||
                        (i >= 0 && mode != 'create_question')
                      ">
                    <button class="delete-btn-response" (click)="removeResponse(i, diplome)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="27" viewBox="0 0 25 27" fill="none">
                        <g>
                          <path
                            d="M17.9851 4.17508H18.6809C18.8655 4.17508 19.0425 4.10177 19.173 3.97127C19.3035 3.84078 19.3768 3.66379 19.3768 3.47924C19.3768 3.29469 19.3035 3.11769 19.173 2.9872C19.0425 2.8567 18.8655 2.78339 18.6809 2.78339H15.2017V2.08754C15.2 1.5344 14.9796 1.00438 14.5884 0.613252C14.1973 0.222119 13.6673 0.001652 13.1141 0H8.93906C8.38591 0.001652 7.8559 0.222119 7.46477 0.613252C7.07363 1.00438 6.85317 1.5344 6.85151 2.08754V2.78339H3.69585C3.5113 2.78339 3.33431 2.8567 3.20381 2.9872C3.07331 3.11769 3 3.29469 3 3.47924C3 3.66379 3.07331 3.84078 3.20381 3.97127C3.33431 4.10177 3.5113 4.17508 3.69585 4.17508H4.06813V14.6128C4.06813 15.5355 4.43469 16.4205 5.08717 17.073C5.73965 17.7255 6.62461 18.092 7.54736 18.092H14.5058C15.4286 18.092 16.3135 17.7255 16.966 17.073C17.6185 16.4205 17.9851 15.5355 17.9851 14.6128V4.17508ZM9.6349 13.2211C9.6349 13.4056 9.56159 13.5826 9.43109 13.7131C9.3006 13.8436 9.12361 13.9169 8.93906 13.9169C8.75451 13.9169 8.57751 13.8436 8.44702 13.7131C8.31652 13.5826 8.24321 13.4056 8.24321 13.2211V7.65432C8.24321 7.46977 8.31652 7.29278 8.44702 7.16228C8.57751 7.03178 8.75451 6.95847 8.93906 6.95847C9.12361 6.95847 9.3006 7.03178 9.43109 7.16228C9.56159 7.29278 9.6349 7.46977 9.6349 7.65432V13.2211ZM13.81 13.2211C13.81 13.4056 13.7367 13.5826 13.6062 13.7131C13.4757 13.8436 13.2987 13.9169 13.1141 13.9169C12.9296 13.9169 12.7526 13.8436 12.6221 13.7131C12.4916 13.5826 12.4183 13.4056 12.4183 13.2211V7.65432C12.4183 7.46977 12.4916 7.29278 12.6221 7.16228C12.7526 7.03178 12.9296 6.95847 13.1141 6.95847C13.2987 6.95847 13.4757 7.03178 13.6062 7.16228C13.7367 7.29278 13.81 7.46977 13.81 7.65432V13.2211ZM13.81 2.78339H8.24321V2.08754C8.24321 1.90299 8.31652 1.726 8.44702 1.5955C8.57751 1.46501 8.75451 1.39169 8.93906 1.39169H13.1141C13.2987 1.39169 13.4757 1.46501 13.6062 1.5955C13.7367 1.726 13.81 1.90299 13.81 2.08754V2.78339Z"
                            fill="#EE6352" />
                        </g>
                        <defs>
                          <filter id="filter0_d_1970_2873" x="0" y="0" width="24.375" height="26.0918"
                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset dx="1" dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1970_2873" />
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1970_2873"
                              result="shape" />
                          </filter>
                        </defs>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="mt-3 mb-5">
                <button class="btn add-reponse" [disabled]="
                      responses.length >= 4 ||
                      responses.controls[0].value.response_FR == '' 
                    " (click)="addResponse()">
                  Ajouter une réponse
                </button>
              </div>
              <span class="requirements mt-5" *ngIf="responses.length < 2">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_379_198)">
                    <path
                      d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                      fill="#EE6352" />
                  </g>
                  <defs>
                    <clipPath id="clip0_379_198">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                &nbsp;Vous devez ajouter au moins deux réponses.</span>
            </div>
          </form>
          <div class="modal-footer text-center">
            <button (click)="closeModal()" data-bs-dismiss="modal" id="kt_customers_export_cancel"
              class="footer-btn annuler me-3">
              Annuler
            </button>
                  <button [disabled]="state ==1?
            (questionForm.invalid ||
            responses.length < 2 ||
            hasDuplicateResponses()  || isDuplicateResponseErrorShown):(questionForm.get('question_FR')?.invalid || questionForm.get('time')?.invalid)" (click)="confirmer()" type="submit" id="kt_customers_export_submit" class="footer-btn confirmer">
              <span class="indicator-label">Confirmer</span>
              <span class="indicator-progress">Please wait...
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
          <!--end::Form-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>
</ng-template>